import { DialogContentText, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useId } from 'react';
import { CgClose } from 'react-icons/cg';
import { Button } from '../atoms/Button';
import SimpleInputText from '../atoms/SimpleInputText';
import SubtitleText from '../atoms/SubtitleText';

interface Props {
	title: string;
	description?: string;
	reason?: string;
	setReason?: (value: string) => void;
	isOpen: boolean;
	isLoading?: boolean;
	setIsOpen: (value: boolean) => void;
	onConfirmation: () => void;
	showReasonField?: boolean;
}

export const ReasonDialog = ({
	title,
	description,
	reason = '',
	setReason,
	isOpen,
	setIsOpen,
	onConfirmation,
	showReasonField = true,
	isLoading = false,
}: Props) => {
	const id = useId();
	const shouldConfirmButtonBeDisabled = showReasonField && !reason.trim();

	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: '12px',
					boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
					overflowY: 'auto',
					height: 'auto',
					width: '100%',
					maxWidth: '30rem',
				},
			}}
			slotProps={{ backdrop: { sx: { background: 'rgba(0, 0, 0, 0.25)' } } }}
			open={isOpen}
			onClose={() => setIsOpen(false)}
		>
			<DialogTitle>
				<div className="flex h-auto items-center justify-between">
					<SubtitleText className="text-[19px]" subtitle={title} />
					<IconButton onClick={() => setIsOpen(false)}>
						<CgClose />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				{description && (
					<DialogContentText id={id} sx={{ width: '100%' }}>
						<div className="text-[18px] mb-6 w-full text-black">
							{description}
						</div>
					</DialogContentText>
				)}
				{showReasonField && setReason && (
					<SimpleInputText
						title="Motivo"
						value={reason}
						setState={setReason}
						width="100%"
						multiline={true}
						rows={2}
						labelClassName="text-[14px]"
						containerClassName="w-full"
						inputStyle={{ padding: 0 }}
						autoFocus
						required
					/>
				)}
			</DialogContent>
			<DialogActions
				sx={{
					width: 'full',
					display: 'flex',
					justifyContent: 'space-between',
					padding: `${showReasonField ? '10px' : '0'} 24px 25px`,
				}}
			>
				<Button
					type="button"
					className="min-w-36 h-8 border-2 border-[#193CB9] bg-white text-[#193CB9] hover:bg-[#e9eaf1]"
					onClick={() => setIsOpen(false)}
					disabled={isLoading}
				>
					Cancelar
				</Button>
				<Button
					type="button"
					className={`min-w-40 h-8 ${shouldConfirmButtonBeDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
					onClick={onConfirmation}
					isLoading={isLoading}
					disabled={shouldConfirmButtonBeDisabled}
				>
					Confirmar
				</Button>
			</DialogActions>
		</Dialog>
	);
};
